import { render } from "./Header.ConfigurationDropdownMenu.vue?vue&type=template&id=fec9725a&scoped=true"
import script from "./Header.ConfigurationDropdownMenu.vue?vue&type=script&lang=ts"
export * from "./Header.ConfigurationDropdownMenu.vue?vue&type=script&lang=ts"

import "./Header.ConfigurationDropdownMenu.vue?vue&type=style&index=0&id=fec9725a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fec9725a"

export default script